export default __webpack_public_path__ + "static/2-b81c570ae06563a687b5d00ef3b29ece.jpeg";